// extracted by mini-css-extract-plugin
export default {"container":"Home_container__qRlyu","logo_box":"Home_logo_box__ZRMLw","gold":"Home_gold__NhCZg","small_circle_box":"Home_small_circle_box__JN3PF","silver":"Home_silver__uUeG2"};